import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PaperCard } from 'components/Card';
import { paths } from 'routes';

export const Error = ({message = '', standalone = false}) => {
  const { t } = useTranslation();
  return (
    <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 368 }} maxWidth={{ sm: 368 }} sx={{ ...(standalone ? { my: 5 } : { mb: 5 }) }}>
      <Stack>
        <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
          {t('website:auth.error.heading')}
        </Typography>
        <Stack sx={{ textAlign: 'center' }}>
          <Typography variant="body1">{t('website:auth.error.description')}</Typography>
          {message.length > 0 && (
            <Typography variant="body1">{t('website:auth.error.messagePrefix', { message })}</Typography>
          )}
          <Button
            size="large"
            variant="contained"
            color="primary"
            sx={{
              mt: 2,
              mb: 0.5,
              bgcolor: "primary.light",
              '&:hover': {
                backgroundColor: "primary.light",
              },
            }}
            href={paths.homepage}
          >
            {t('website:auth.confirmationSent.returnToHomeButton')}
          </Button>
        </Stack>
      </Stack>
    </PaperCard>
  );
};
